function formatDateTime(date: string | Date | undefined) {
  if (!date) {
    return
  }
  const dateObject = new Date(date)

  const year = ('0000' + dateObject.getUTCFullYear().toString()).slice(-4)
  const month = ('00' + (dateObject.getUTCMonth() + 1).toString()).slice(-2)
  const day = ('00' + dateObject.getUTCDate().toString()).slice(-2)
  const hours = ('00' + dateObject.getUTCHours().toString()).slice(-2)
  const minutes = ('00' + dateObject.getUTCMinutes().toString()).slice(-2)
  const seconds = ('00' + dateObject.getUTCSeconds().toString()).slice(-2)

  // Since some calendars don't add 0 second events, we need to remove time if there is none...
  let time = ''
  if (hours !== '00' || minutes !== '00' || seconds !== '00') {
    time = 'T' + hours + minutes + seconds
  }

  return year + month + day + time + 'Z'
}

export default function (
  filename: string,
  drupalUuid: string,
  summary: string,
  description: string,
  occurrences: {
    start?: { icsFormat: string }
    end?: { icsFormat: string }
  }[],
  url: string,
  location?: string | undefined,
  organizerName?: string | undefined,
  organizerEmail?: string | undefined,
  rrule?: string | undefined,
) {
  let icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//bs.ch//Veranstaltungskalender Kanton Basel Stadt
CALSCALE:GREGORIAN
METHOD:PUBLISH
`
  for (const [index, occurrence] of occurrences.entries()) {
    icsContent += `BEGIN:VEVENT
DTSTAMP:${formatDateTime(new Date())}
DTSTART:${formatDateTime(occurrence?.start?.icsFormat)}
DTEND:${formatDateTime(occurrence?.end?.icsFormat)}
UID:${drupalUuid}+${index}@bs.ch
SUMMARY:${summary}
DESCRIPTION:${description}
URL:${url}
`
    if (location) {
      icsContent += `LOCATION:${location}
`
    }

    if (organizerName && organizerEmail) {
      icsContent += `ORGANIZER;CN=${organizerName}:mailto:${organizerEmail}
`
    }

    if (rrule) {
      icsContent += `RRULE:${rrule}
`
    }

    icsContent += `END:VEVENT
`
  }

  icsContent += 'END:VCALENDAR'

  icsContent = icsContent.trimEnd()

  const a = document.createElement('a')
  a.download = filename + '.ics'
  a.href = 'data:text/calendar;charset=utf8,' + encodeURI(icsContent)

  a.click()
}
